"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.historyMiddlewares = void 0;

var _createQueryMiddleware = _interopRequireDefault(require("farce/lib/createQueryMiddleware"));

var _qs = _interopRequireDefault(require("qs"));

var _queryStringParsing = require("./queryStringParsing");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var historyMiddlewares = [(0, _createQueryMiddleware.default)({
  parse: _queryStringParsing.queryStringParsing,
  stringify: _qs.default.stringify
})];
exports.historyMiddlewares = historyMiddlewares;
//# sourceMappingURL=historyMiddlewares.js.map